import React from 'react';
import utilsFunction from "../../../utils/utilsFunction";
import numericFunction from "../../../utils/NumericFunction";
import {formatToPersianAddComma} from "../../../utils/CommaSeparator";

function PageRowsPrintSellFactor({data, myColumns, rows}) {


  let totalSum = 0;
  return (<div className={"sellFactorSadanPrint"}>

    <table className={" rtl"}>
      <tbody>
      <tr>
        <td>ردیف</td>
        {myColumns.map(v => <td>{v.title}</td>)}
      </tr>
      {rows.map((singleRow, index) => {

        const rowIndex = singleRow?.rowIndex
        const productCode = singleRow?.CKALA
        const productName = singleRow?.NKALA
        const productPrice = singleRow?.GHVAHED
        const productTE = singleRow?.TE
        const productPriceSum = singleRow?.JAM
        totalSum += +productPriceSum

        return <>
          <tr>
            <td>{formatToPersianAddComma(rowIndex)}</td>
            <td>{productCode}</td>
            <td>{productName}</td>
            <td>{formatToPersianAddComma(productPrice)}</td>
            <td>{numericFunction.e2p(productTE)}</td>
            <td>{formatToPersianAddComma(productPriceSum)}</td>
          </tr>
        </>
      })}

      </tbody>
      <tfoot>
      <tr>
        <td colSpan={5} className={'text-center'}> جمع صفحه </td>
        <td className={'text-center'}> {formatToPersianAddComma(totalSum)}</td>
      </tr>
      </tfoot>
    </table>

  </div>);
}

export default PageRowsPrintSellFactor;